import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Link,
  Button,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import api from "services/api";
import Swal from "sweetalert2";
import styles from "./styles.module.scss";

interface Servicos {
  id: number;
  nm_servico: string;
  link_servico: string;
  desc_servico: string;
}

const ServicosPortal = () => {
  const [servicos, setServicos] = useState<Servicos[]>([]);
  const [pageLoading, setPageLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function getServicos() {
      try {
        const response = await api.get("/servicos");
        setServicos(response.data);
        setPageLoading(false);
        navigate("/");
      } catch (err) {
        console.log(err);

        Swal.fire({
          icon: "error",
          title: "Erro ao listar os atalhos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    getServicos();
  }, [navigate]);

  return pageLoading ? (
    <Box
      as="section"
      display="flex"
      w="100%"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress isIndeterminate color="blue.200" />
    </Box>
  ) : (
    <Box className={styles.servicos}>
      {servicos.length > 0 ? (
        servicos.map((servico) => (
          <Link
            key={servico.id}
            href={servico.link_servico}
            isExternal
            _hover={{
              textDecoration: "none",
            }}
            maxWidth="350px"
            width="100%"
            height="max-content"
          >
            <Button className={styles.btn} key={servico.id} colorScheme="blue">
              <div className={styles.title}>{servico.nm_servico}</div>
              <div className={styles.desc}>{servico.desc_servico}</div>
            </Button>
          </Link>
        ))
      ) : (
        <Alert status="info">
          <AlertIcon />
          Nenhum atalho cadastrado
        </Alert>
      )}
    </Box>
  );
};

export default ServicosPortal;
